/**
 * Builds the `invitation_clicked` event fired for the three click targets
 * that exist on an invite card today — accept, decline, and the "See Event"
 * link shown on already-accepted HubEvent invites. See Invitations/index.jsx.
 *
 * Project/hub/sender names and avatars aren't clickable in the current UI,
 * so they aren't instrumented — deliberately scoped to what exists rather
 * than growing the UI to make more of it trackable. Tracked separately as a
 * follow-up issue.
 */

import { getSessionId } from "./session";
import type { InvitationClickedAction, InvitationClickedEvent } from "./types";

interface InvitationClickedInput {
  inviteId: number;
  inviteType: "Project" | "Hub" | "HubEvent";
  action: InvitationClickedAction;
}

export const buildInvitationClickedEvent = ({
  inviteId,
  inviteType,
  action,
}: InvitationClickedInput): InvitationClickedEvent => ({
  name: "invitation_clicked",
  occurred_at: new Date().toISOString(),
  session_id: getSessionId(),
  hub_id: null,
  project_id: null,
  properties: {
    invite_id: inviteId,
    invite_type: inviteType,
    action,
  },
});
